module.exports = __webpack_public_path__ + "img/svg/info.86450fb3b6ce03cc8c8e83809ae38b4a.svg";